import { useMemo } from 'react';
import { useSubscriptions } from '@adsk/alloy-provider';
const useProductsAccessTypes = () => {
  const {
    data: userSubscriptionsData,
    loading: userSubscriptionsLoading
  } = useSubscriptions();
  const result = useMemo(() => userSubscriptionsData === null || userSubscriptionsData === void 0 ? void 0 : userSubscriptionsData.reduce((productsAccessTypes, subscription) => {
    if (subscription.status === 'active') {
      subscription.products.forEach(product => {
        const index = productsAccessTypes.findIndex(item => item.productType === product.productKey);
        if (index === -1) {
          productsAccessTypes.push({
            productType: product.productKey,
            type: subscription.type
          });
        } else {
          const accessType = productsAccessTypes[index].type;
          if (accessType !== 'paid' && subscription.type === 'paid') {
            productsAccessTypes[index].type = subscription.type;
          }
        }
      });
    }
    return productsAccessTypes;
  }, []), [userSubscriptionsData]);
  return {
    loading: userSubscriptionsLoading,
    data: result
  };
};
export { useProductsAccessTypes };
//# sourceMappingURL=useProductsAccessTypes.js.map